<template>
  <div id="work-in-progress-page" v-if="!loading">
    <div class="flex-grow my-4">
      <h1>{{ $t('WorkInProgress') }}</h1>
    </div>

    <div class="vx-card">
      <grid-panel
          :auto-size="true"
          :column-defs="notReceivedColumnDefs"
          :url="quotationListUrl"
          :apiParams="apiParams"
          :gridOptions="gridOptionsTwo"
          :defaultColDef="defaultColDef"
          :headerTextWrap="true"
      >
        <template slot="right">
          <date-range-picker class="ml-4" @update:startDate="startDate = $event" @update:endDate="endDate = $event" />
        </template>

      </grid-panel>
    </div>
    </div>
</template>

<script>
  import GridPanel from '@/views/components/ag-grid/GridPanel';
  import GridActionsMenu from "../../components/extra-components/GridActionsMenu";
  import QuotationListConfig from "../../../grids/WorkInProgress/QuotationListConfig";
  import DateRangePicker from "../../components/calendar/DateRangePicker";
  import CellRendererDate from "../../components/ag-grid/cell-renderer/CellRendererDate";
  import CellRendererAction from "../../components/ag-grid/cell-renderer/CellRendererAction";
  import CellRendererCurrency from "../../components/ag-grid/cell-renderer/CellRendererCurrency";
  import SetGridOptionsMixin from "@/components/mixins/SetGridOptionsMixin";
  import ToolTipRenderer from '@/views/components/ag-grid/components/ToolTipRenderer';
  import { TABLE_IDENTIFIER_FW_SUBMISSION_ID } from '@/constants'
  import moment from 'moment';

  export default {
    components: {
      GridPanel,
      GridActionsMenu,
      DateRangePicker,
      CellRendererDate,
      CellRendererAction,
      CellRendererCurrency,
      ToolTipRenderer,
    },
    mixins: [SetGridOptionsMixin],
    data() {
      return {
        referralListUrl: (params) => this.$api.referralList.list(params),
        quotationListUrl: (params) => this.$api.quotationList.list(params),
        startDate: null,
        endDate: null,
        gridOptionsOne: {},
        gridOptionsTwo: {},
        defaultColDef: {
          minWidth: 100,
          resizable: true,
          sortable: true,
          wrapText: true,
          tooltipComponent: 'ToolTipRenderer',
        },
        loading: true,
        firmOrdersWidthsConfig: null,
        notReceivedWidthsConfig: null,
        firmOrdersColumnDefs: [],
        notReceivedColumnDefs: [],
      };
    },
    computed: {
      apiParams() {
        // Only set these when we have the full date range available
        // Otherwise it loads the endpoint twice and fails the first time due to missing parameters
        if (!this.startDate || !this.endDate) {
          return null;
        }

        return {
          startDate: (this.startDate) ? moment(this.startDate).format('YYYY-MM-DD') : null,
          endDate: (this.endDate) ? moment(this.endDate).format('YYYY-MM-DD') : null
        }
      },
    },
    methods: {
      async setColumnDefs() {
        this.loading = true;

        const notReceivedWidthsConfig = await this.setGridWidthOptions(TABLE_IDENTIFIER_FW_SUBMISSION_ID);
        this.setNotReceivedColumnDefs(notReceivedWidthsConfig);

        this.loading = false;
      },
      setNotReceivedColumnDefs(notReceivedWidthsConfig) {
        this.notReceivedColumnDefs = this.getColumnDefsWithWidths(QuotationListConfig, notReceivedWidthsConfig);
      },
    },
    async created() {
      await this.setColumnDefs();
    },
  };
</script>
